export enum AuthResult {
  AccessToken = "AccessToken",
  ExpiresIn = "ExpiresIn",
  IdToken = "IdToken",
  RefreshToken = "RefreshToken",
  TokenType = "TokenType",
}
